/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {useEffect} from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {Layout, LayoutSplashScreen} from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { useAuth0 } from "@auth0/auth0-react";
import {actions} from "../app/modules/Auth/_redux/authRedux";

export function Routes() {
    
    const {
        user,
        isAuthenticated,
        loginWithRedirect,
        isLoading,
        logout, 
        getIdTokenClaims
      } = useAuth0();
    console.log("user: ", user);
    const logoutWithRedirect = () =>
    logout({
    returnTo: window.location.origin,
    });      

    const { authState } = useSelector(
        (state) => ({ authState: state.auth }),
        shallowEqual
      );
    
    const {redirectTo} = authState;
    
    
    console.log("In Routes", window.location.pathname, "isAuthenticated", isAuthenticated);
    let loc = window.location.pathname;
      const dispatch = useDispatch();
    // const layoutDispatch = useContext(LayoutContext.Dispatch);
    useEffect(() => {
        async function getUserData() {
            console.log("in routes use effect", isAuthenticated, window.location.pathname, loc)
            if(user) {
                var claims = await getIdTokenClaims();
                console.log("Claims", claims);
                dispatch(actions.setUser(user));
            } else if(loc == "/auth/logout") {
                dispatch(actions.SetRedirectUrl("/"));
                console.log("Calling logout....");
                logout({
                    returnTo: '/'
                  });
            } else if(!isAuthenticated && loc !== "/auth/login") {
                dispatch(actions.SetRedirectUrl(loc));
            }
        }
        getUserData();
    }, [loc, isAuthenticated, dispatch]);

    return (
        <Switch>
            {isLoading &&
            <Layout>
                <LayoutSplashScreen/>
            </Layout>                
            }

            {!isLoading && !isAuthenticated ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage returnTo={window.location.pathname} />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to={redirectTo || '/'} />
            )}

            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>

            {!isLoading && !isAuthenticated ? (

            /*Redirect to `/auth` when user is not authorized*/
            <Redirect to="/auth/login"/>
            ) : (
            <Layout>
                <BasePage/>
            </Layout>
        )}


        </Switch>
    );
}

